module.exports = __webpack_public_path__ + "img/timetable-nolesson.aeff3db6.png";